// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DonationCodeTomSelectController from "./donation_code_tom_select_controller"
application.register("donation-code-tom-select", DonationCodeTomSelectController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PaymentsController from "./payments_controller"
application.register("payments", PaymentsController)

import InvoiceController from "./invoice_controller"
application.register("invoice", InvoiceController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import RegionController from "./region_controller"
application.register("region", RegionController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import UploadPreviewController from "./upload_preview_controller"
application.register("upload-preview", UploadPreviewController)
